import { useContext, useCallback } from "react";
import { useSelector } from "react-redux";

import { PermissionsContext } from "context/AppProvider/PermissionsContext";

import { useAuth0 } from "@auth0/auth0-react";

import { PERMISSIONS } from "constants/portal";

const useAllowEditWorkflow = () => {
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const { userPermissions } = useContext(PermissionsContext);
  const { userFlows } = useSelector((store) => store?.portal?.flows);
  const { user } = useAuth0();

  const allowEditWorkflow = useCallback(
    (isReadOnlyAccess = false) => {
      const userFlow = userFlows?.find(
        (userFlow) =>
          userFlow.flow_id === currentSavedFlow?.id && userFlow.user_id === user?.cxfUserId
      );

      const isEditor = userFlow?.access_type === "editor";

      const allowEditWorkflows = userPermissions?.find(
        (permission) => permission.name === PERMISSIONS.EDIT_WORKFLOWS
      )?.value;

      const allowEditAnyWorkflows = userPermissions?.find(
        (permission) => permission.name === PERMISSIONS.EDIT_ANY_WORKFLOWS
      )?.value;

      const flowOwner = currentSavedFlow?.created_by_id === user?.cxfUserId;

      if (allowEditAnyWorkflows) {
        return true;
      }

      if (isReadOnlyAccess) {
        return false;
      }

      if ((flowOwner || isEditor) && allowEditWorkflows) {
        return true;
      }

      return false;
    },
    [userPermissions, currentSavedFlow, user, userFlows]
  );
  // const allowEditWorkflow = allowEditWorkflows || allowEditAllWorkflows || flowOwner;
  const isFlowDraft =
    currentSavedFlow?.shared_status === "test" || currentSavedFlow?.shared_status === "draft";

  return { allowEditWorkflow, isFlowDraft };
};

export default useAllowEditWorkflow;
